import React, { useEffect, useState } from "react";
import Main from "../../../layout/main/Main";
import ProductList from "./products/list/ProductList";
import BrandList from "./brands/list/BrandList";
import { Link, useSearchParams } from "react-router-dom";
import {
	ButtonContainer,
	ChildrenContainer,
	AntdButton,
	PageContainer,
	PageHeaderBlock,
	TitleBlock,
	PageTitle,
	PageSub,
	ContentShell,
} from "./styles";
import { CONSTANTS } from "../../../../utils/constants";

export default function Items({ clientId }) {
	const [filter, setFilter] = useState(CONSTANTS.SELECTOR_PRODUCT);
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");

	const get_filter = () => {
		setFilter(
			localStorage.getItem("itemsFilter")
				? localStorage.getItem("itemsFilter")
				: CONSTANTS.SELECTOR_PRODUCT,
		);
	};

	useEffect(() => {
		get_filter();
	}, []);

	const changeFilter = (value) => {
		setFilter(value);
		localStorage.setItem("itemsFilter", value);
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						{uri ? (
							<Link to={"/" + uri}>Configuración General</Link>
						) : (
							<Link to="/">Home</Link>
						)}
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						Productos y Marcas
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>
			<Main.Body>
				<PageContainer>
					<PageHeaderBlock>
						<TitleBlock>
							<PageTitle>Productos y Marcas</PageTitle>
							<PageSub>Gestioná productos y marcas desde un solo lugar</PageSub>
						</TitleBlock>

						<ButtonContainer>
							<AntdButton
								$active={filter === CONSTANTS.SELECTOR_PRODUCT}
								onClick={() => changeFilter(CONSTANTS.SELECTOR_PRODUCT)}
							>
								Productos
							</AntdButton>

							<AntdButton
								$active={filter === CONSTANTS.SELECTOR_BRAND}
								onClick={() => changeFilter(CONSTANTS.SELECTOR_BRAND)}
							>
								Marcas
							</AntdButton>
						</ButtonContainer>
					</PageHeaderBlock>

					<ContentShell>
						<ChildrenContainer>
							{filter === CONSTANTS.SELECTOR_PRODUCT && (
								<ProductList uri={uri} clientId={clientId} />
							)}
							{filter === CONSTANTS.SELECTOR_BRAND && (
								<BrandList uri={uri} clientId={clientId} />
							)}
						</ChildrenContainer>
					</ContentShell>
				</PageContainer>
			</Main.Body>
		</Main>
	);
}
